import useMutationObserver from '../useMutationObserver'
import { type RefObject, useCallback, useMemo } from 'react'

function useAttributeObserver<T extends HTMLElement>(ref: RefObject<T>, attributeName: string) {
  const filter = useCallback(
    (mutation: MutationRecord) => mutation.type === 'attributes' && mutation.attributeName === attributeName,

    [attributeName]
  )
  const record = useMutationObserver(ref, filter, { attributes: true })

  const result = useMemo(
    () => ({ oldValue: record?.oldValue ?? null, newValue: ref.current?.getAttribute(attributeName) }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [record, attributeName]
  )

  return result
}

export default useAttributeObserver
